import { type ContentObjectRedux, isProgramContentObject } from 'models';

export const canLikeContentObject = ({ contentObject }: { contentObject: ContentObjectRedux }) =>
  !isProgramContentObject(contentObject) &&
  contentObject.post_in_communities.every((community) => community.settings.view_members);
